export const environment = {
  production: false,
  apiEndpoint: 'https://beta-api.sen3i.com/api',
  version: '2.1.9',
  languages: [
    {
      name: 'English',
      url: 'assets/flags/en.png',
      code: 'en',
      active: true,
    },
    {
      name: 'Bahasa',
      url: 'assets/flags/ms.png',
      code: 'ms',
      active: true,
    },
  ],
  firebase: {
    apiKey: 'AIzaSyB0Q9ZtDP-7bPEr-4uDnpJRLMBdmjllruc',
    authDomain: 'overwatch-b6116.firebaseapp.com',
    projectId: 'overwatch-b6116',
    storageBucket: 'overwatch-b6116-bucket',
    messagingSenderId: '240386671213',
    appId: '1:240386671213:web:4b1a5e049c453d23453564',
    databaseURL:
      'https://overwatch-b6116-default-rtdb.asia-southeast1.firebasedatabase.app/',
    vapidKey:
      'BNwlAYY519kGbiW_IbTGiwOOqYCeYzJ6jYLnBn78iHlAa4bSAzqKg5PTtDJemt80xXMPRAmIODmPK1a6kFdhM0g',
  },
  liveVideo: {
    type : 'AntRTC'
  },
  issueApiEndpoint: 'https://issuelog.dappleworks.com',
};
 